import React from "react";

function MessageContent() {
  return (
    <div className="message-container">
      <div className="message-wraper">
        <div className="emoji" />
        <div className="message">
          <p>
	  함께 웃던 기억들이 사랑이라는 이름으로
	  <br/>
	  서로의 마음속 깊이 자리 잡았습니다.
	  <br/>
	  이제 두 사람이 하나가 될
	  <br/>
	  인생의 여정을 시작하려 합니다.
	  <br/>
	  귀한걸음 하시어 축복해주시면
	  <br/>
	  더없는 격려와 기쁨으로 간직하겠습니다.
	  <br/>
          </p>
        </div>
        <div className="contact">
          <div className="dic">
            <span>한웅진</span>
            <span>길정자의</span>
            <span className="role">장남</span>
            <span className="name">상현</span>
			<span className="phonecall">
				<a href="tel:010-4129-3090"> 📞</a>
			</span>
          </div>
          <div className="dic">
            <span>이지형</span>
            <span>김경희의</span>
            <span className="role">장녀</span>
            <span className="name">채희</span>
			<span className="phonecall">
				<a href="tel:010-5063-2954"> 📞</a>
			</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MessageContent;
